import { signOut as signOutFB } from "firebase/auth"

import { auth } from "./auth"

export const signOut = () => {
  return signOutFB(auth)
}
